import { useEffect, useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";

const featureslist = [
  {
    src: "https://d1cj3qoxnek6r9.cloudfront.net/home/bespoke/uicustom1.webp",
    caption: "Making your website feel like you",
    h5: "Custom UI",
    p1: "Designed uniquely",
    p2: "Smooth, intuitive user experience",
    p3: "Fully responsive across devices",
    p4: "Modern interactive visual elements",
  },

  {
    src: "https://d1cj3qoxnek6r9.cloudfront.net/home/bespoke/ecommerce1.webp",
    caption: "Turning clicks into customers",
    h5: "Advanced e-commerce experiences",
    p1: "Smart product management",
    p2: "Seamless checkout flows",
    p3: "Personalised shopping experiences",
    p4: "Modern interactive visual elements",
  },
  {
    src: "https://d1cj3qoxnek6r9.cloudfront.net/home/bespoke/security1.webp",
    caption: "Keeping you safe, steady and always online",
    h5: "Secure hosting and maintenance",
    p1: "Managed hosting solutions",
    p2: "Automatic backups and updates",
    p3: "Real-time monitoring",
    p4: "Ongoing technical support",
  },
  {
    src: "https://d1cj3qoxnek6r9.cloudfront.net/home/bespoke/responsivedes1.webp",
    caption: "Looking perfect on any screen at any time!",
    h5: "Multi-platform Responsiveness",
    p1: "Device-specific layouts",
    p2: "Adaptive image scaling",
    p3: "Touch-friendly design",
    p4: "Cross-border consistency",
  },
  {
    src: "https://d1cj3qoxnek6r9.cloudfront.net/home/bespoke/custom1.webp",
    caption: "Keeping you fast and findable",
    h5: "Performance and SEO optimisation",
    p1: "Speed-first development",
    p2: "SEO best practices",
    p3: "Accessibility compliance",
    p4: "Analytics setup",
  },
];

const BespokeCarousel = () => {
  const [index, setIndex] = useState(0);
  const [direction, setDirection] = useState("vertical"); // 'vertical' or 'horizontal'
  const middleIndex = Math.floor(featureslist.length / 2);

  // Auto rotate
  useEffect(() => {
    const interval = setInterval(() => {
      handleNext();
    }, 5000);
    return () => clearInterval(interval);
  }, [index]);

  // Detect screen width for direction
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 1024) setDirection("horizontal");
      else setDirection("vertical");
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleNext = () => {
    setIndex((prev) => (prev + 1) % featureslist.length);
  };

  const handlePrev = () => {
    setIndex((prev) => (prev - 1 + featureslist.length) % featureslist.length);
  };

  // Swipe gesture (for mobile)
  useEffect(() => {
    let startY = 0;
    const handleTouchStart = (e) => (startY = e.touches[0].clientY);
    const handleTouchEnd = (e) => {
      const diffY = e.changedTouches[0].clientY - startY;
      if (diffY > 50) handlePrev();
      if (diffY < -50) handleNext();
    };
    window.addEventListener("touchstart", handleTouchStart);
    window.addEventListener("touchend", handleTouchEnd);
    return () => {
      window.removeEventListener("touchstart", handleTouchStart);
      window.removeEventListener("touchend", handleTouchEnd);
    };
  }, []);

  return (
    <div className="carousel-wrapper">
      <div className="carousel-container">
        <div
          className={`home-cards-container ${
            direction === "horizontal" ? "horizontal" : "vertical"
          }`}
        >
          {featureslist.map((image, i) => {
            const relativeIndex =
              (i - index + featureslist.length) % featureslist.length;
            const offset = relativeIndex - middleIndex;

            const zIndex = featureslist.length - Math.abs(offset);
            const cardSpacing = window.innerWidth < 800 ? 24 : 30;
            const distance = offset * cardSpacing;
            const scale = 1 - Math.abs(offset) * 0.05;
            const transform =
              direction === "horizontal"
                ? `translateX(${distance}px) scale(${scale})`
                : `translateY(${distance}px) scale(${scale})`;

            return (
              <div
                key={i}
                className={`card ${offset === 0 ? "center" : ""}`}
                style={{
                  zIndex,
                  opacity: 1 - Math.abs(offset) * 0.1,
                  transform,
                  filter: `blur(${Math.abs(offset) * 1}px)`,
                }}
              >
                <div className="feature-content">
                  <h5>{image.h5}</h5>
                  <div className="img-and-points-container">
                    <img src={image.src} alt={`Feature ${i + 1}`} />
                    <div className="points">
                      <div className="point">
                        <Icon icon="charm:circle-tick" className="icon" />
                        <span>{image.p1}</span>
                      </div>{" "}
                      <div className="point">
                        <Icon icon="charm:circle-tick" className="icon" />
                        <span>{image.p2}</span>
                      </div>{" "}
                      <div className="point">
                        <Icon icon="charm:circle-tick" className="icon" />
                        <span>{image.p3}</span>
                      </div>{" "}
                      <div className="point">
                        <Icon icon="charm:circle-tick" className="icon" />
                        <span>{image.p4}</span>
                      </div>
                    </div>
                  </div>
                  <span className="caption">{image.caption}</span>
                </div>
              </div>
            );
          })}
        </div>

        {/* <div className="carousel-controls">
          <button onClick={handlePrev} className="arrow-btn">
            <span className="prev">
              <Icon icon="maki:arrow" height="22" width="22" className="" />
            </span>
          </button>
          <span className="slide-indicator">
            {index + 1} / {featureslist.length}
          </span>
          <button onClick={handleNext} className="arrow-btn">
            <span className="next">
              <Icon icon="maki:arrow" height="22" width="22" />
            </span>
          </button>
        </div>*/}
      </div>
    </div>
  );
};
{
  /*
    src: "https://d1cj3qoxnek6r9.cloudfront.net/home/bespoke/booking-systems.png",
    caption: "Scheduling made simple and easy",
    h5: "Tailored booking & appointment systems",
    p1: "Custom scheduling workflows",
    p2: "Automated confirmations and reminders",
    p3: "Calendar integration",
    p4: "Secure payment and deposit options",
  */
}
export default BespokeCarousel;
